// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"zO-z","upvoteIcon":"AO-z","downvoteIcon":"BO-z","feedbackIcon":"CO-z"};